<div class="table-container">
    <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="Name">
            <tr mat-header-row>
                <th mat-header-cell *matHeaderCellDef>
                    <div class="table-header">
                        <span>Name</span>
                    </div>
                </th>
            </tr>
            <tr mat-row>
                <td mat-cell *matCellDef="let element" class="align-right">{{element.fileName}}</td>
            </tr>
        </ng-container>

        <ng-container matColumnDef="DocumentType">
            <tr mat-header-row>
                <th mat-header-cell *matHeaderCellDef>
                    <div class="table-header">
                        <span>Document Type</span>
                    </div>
                </th>
            </tr>
            <tr mat-row>
                <td mat-cell *matCellDef="let element" class="align-right">{{element.documentType}}</td>
            </tr>
        </ng-container>

        <ng-container matColumnDef="FileSize">
            <tr mat-header-row>
                <th mat-header-cell *matHeaderCellDef style="width:120px; text-align:right;">
                    <div class="table-header">
                        <span>File Size</span>
                    </div>
                </th>
            </tr>
            <tr mat-row>
                <td mat-cell *matCellDef="let element" class="align-right" style="text-align:right;">{{element.fileSize}}</td>
            </tr>
        </ng-container>        

        <ng-container matColumnDef="Actions">
            <tr mat-header-row>
                <th mat-header-cell *matHeaderCellDef class="actions-col" style="width:130px; text-align:center;">Actions</th>
            </tr>
            <tr mat-row>
                <td mat-cell *matCellDef="let element">
                    <div class="action-buttons">
                        <button *ngIf="element.canPreview || element.canPreviewPdf" (click)="viewDocument(element)" mat-icon-button matSuffix color="accent" matTooltip="Preview document">
                            <mat-icon>visibility</mat-icon>
                        </button>
                        <span *ngIf="!element.canPreview && !element.canPreviewPdf" matTooltip="Preview is unavailable for this document type">
                            <button disabled="disabled" (click)="viewDocument(element)" mat-icon-button matSuffix color="accent">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </span>
                        <button (click)="downloadDocument(element)" mat-icon-button matSuffix color="accent" matTooltip="Download document">
                            <mat-icon>download</mat-icon>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <span class="noData" *ngIf="noAttachmentData">No attachments found!</span>

    <ul *ngIf="false">
        <li *ngFor="let attachment of attachments;">
            <a [href]="'./api/request-doc/bydocid?documentId=' + attachment.id"
               data-fancybox="attachments"
               [attr.data-type]="attachment.extension == 'PDF' ? 'iframe' : null"
               [attr.data-caption]="attachment.fileName">
                <img [src]="attachment.extension == 'PDF' ? 'assets/pdf_icon.png' : ('./api/request-doc/bydocid?documentId=' + attachment.id)" />
            </a>
        </li>
    </ul>
</div>
